<template>
	<div>
		<div class="upload-dynamix-flex">
			<label class="teams-label-font" :class="{ 'w-42': id == 'uploadFile' }"
				>{{ label }}<span v-if="mandatory" class="asterik">*</span></label
			>
			<div
				class="newUploadDoc relativeclass"
				v-b-tooltip.hover.html.bottom
				:title="tooltipContent"
				:class="{
					validationinputfile: showError || maxSize || invalidFile,
					'box-size-docs': id === 'feedback',
					'w-100 ml-1': id == 'uploadFile',
					'w-81': id != 'uploadFile',
					'newUploadDoc-filled':isFileUploaded
				}"
			>
				<b-form-file
					:disabled="disabled"
					ref="uploadFiles"
					:id="id"
					:type="type"
					:placeholder="placeholder"
					v-model="inputData"
					@input="uploadFile"
					:accept="acceptedFileTypes"
				>
				</b-form-file>
				<div
					v-if="!isFileUploaded"
					class="newUploadDoc-innerContent d-flex align-items-center justify-content-center h-100 w-100"
				>
					<div
						@drop.prevent="handleDrop"
						id="laptop-upload"
						class="d-flex align-items-center justify-content-center h-100 w-100"
					>
						<img
							src="../../assets/newdesign/inputcomponent/manage-upload-icon.svg"
							alt=""
						/>
						<span class="newUploadDoc-innerContent-font-blk ml-2">
							Drag & Drop or
						</span>
						<span class="newUploadDoc-innerContent-font-blue ml-2">
							Browse file
						</span>
					</div>
					<div
						id="mobile-upload"
						class="d-flex align-items-center justify-content-between h-100 w-100 px-2"
					>
						<div>
							<div class="asp-small-grey-txt-2">Upload File</div>
							<div class="mobjd-light-txt mt-1">
								( {{ fileFormat.join(", ") }} ) max {{ maxFileSize }} MB
							</div>
						</div>
						<div class="d-flex align-items-center">
							<div class="asp-vertical-line mr-2"></div>
							<div>
								<img
									src="../../assets/newdesign/jdprogress/mobjdprog/upload.svg"
									alt=""
								/>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="newUploadDoc-innerContent h-100 w-100">
					<div
						id="laptop-upload"
						class="relativeclass d-flex align-items-center justify-content-between h-100 w-100"
					>
						<div class="newUploadDoc-innerContent-left d-flex align-items-center" style="width: 80%">
							<img
								src="../../assets/newdesign/inputcomponent/manage-empty-resume-file.svg"
								alt=""
							/>
							<div
								class="newUploadDoc-innerContent-font-blk ml-2 text-truncate"
								style="max-width: 75%"
							>
								{{ uploadedFileName }}
							</div>
						</div>
						<div>
							<img
								class="newUploadDoc-innerContent-replace"
								src="../../assets/newdesign/inputcomponent/manage-replace-icon.svg"
								alt=""
								@click.stop="uploadFile()"
							/>
	
							<img
								class="newUploadDoc-innerContent-delete"
								@click.stop="removeFile()"
								src="../../assets/newdesign/inputcomponent/manage-cancel-resume-icon.svg"
								alt=""
							/>
						</div>
					</div>
					<div
						id="mobile-upload"
						class="d-flex align-items-center pt-2 justify-content-between px-2"
					>
						<div class="d-flex w-75">
							<div>
								<img src="../../assets/icons/mobUpldDoc/doc-uploaded.svg" />
							</div>
							<div class="asp-small-grey-txt-2 ml-1 mt-1 w-75 text-truncate">
								{{ uploadedFileName }}
							</div>
						</div>
						<div class="d-flex justify-content-between">
							<img
								@click="uploadFile()"
								class="newUploadDoc-innerContent-replace"
								src="../../assets/icons/mobUpldDoc/replace_mob.svg"
								alt=""
							/>
	
							<img
								class="newUploadDoc-innerContent-line"
								src="../../assets/icons/mobUpldDoc/card-line.svg"
								alt=""
							/>
	
							<img
								class="newUploadDoc-innerContent-delete"
								@click.stop="removeFile()"
								src="../../assets/icons/mobUpldDoc/delete-mob.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="newInt-required-validation-font mt-1"
			v-if="!showError && invalidFile"
			style="margin-left: 8rem;"
		>
			Invalid File Format
		</div>
		<div
			class="newInt-required-validation-font mt-1"
			v-else-if="!showError && maxSize"
			style="margin-left: 8rem;"

		>
			Max size exceeded
		</div>
	</div>
</template>
   
  <script>
import toast from "../../components/mixin/toast";
export default {
	name: "UploadDocument",
	mixins: [toast],
	props: {
		disabled: Boolean,
		mandatory: Boolean,
		showError: Boolean,
		type: String,
		label: String,
		placeholder: String,
		id: String,
		maxFileSize: String,
		fileFormat: Array,
		vmodel: Object,
	},
	data() {
		return {
			inputData: [],
			isFileUploaded: false,
			maxSize: false,
			invalidFile: false,
			uploadedFileName: null,
			extension: "",
		};
	},
	created() {
		console.log("vmodel", this.vmodel);
		if (
			this.vmodel &&
			this.vmodel.data.uploadFile != "" &&
			this.vmodel.data.uploadFile != undefined && this.vmodel != null
		) {
			console.log("v-models")
			let lastIndex = this.vmodel.data.uploadFile.lastIndexOf("/");
			let some = this.vmodel.data.uploadFile.substring(lastIndex + 1);
			this.inputData = this.vmodel.data.uploadFile;
			this.uploadedFileName = some;
			this.isFileUploaded = true;
			this.$emit("select-value", this.inputData);
		}
		console.log("v-modelss")
	},
	mounted() {
		const fileTag = this.$refs.uploadFiles.$el;
		fileTag.addEventListener("drop", this.handleDrop);
	},
	beforeDestroy() {
		const fileTag = this.$refs.uploadFiles.$el;
		fileTag.removeEventListener("drop", this.handleDrop);
	},
	computed: {
		tooltipContent() {
			if (!this.isFileUploaded) {
				return `
          Upload your ${this.placeholder}<br>
          (${this.fileFormat.join(", ")})
          max ${this.maxFileSize} MB
        `;
			} else {
				return "";
			}
		},

		acceptedFileTypes() {
			const fileExtensions = this.fileFormat.map((format) => `.${format}`);
			return fileExtensions.join(",");
		},
	},
	methods: {
		handleDrop(event) {
			event.preventDefault();
			const files = event.dataTransfer.files;
			if (files.length > 0) {
				const file = files[0];
				this.processFile(file);
			}
		},
		uploadFile(event) {
			if (event instanceof File) {
				this.processFile(event);
			}
		},
		processFile(file) {
			const fileName = file.name;
			const fileSize = file.size;
			const fileExtension = fileName.split(".").pop().toLowerCase();
			const allowedExtensions = this.fileFormat.map((ext) => ext.toLowerCase());

			if (fileSize > this.maxFileSize * 1024 * 1024) {
				this.errorModal("File size exceeds maximum allowed size");
				this.maxSize = true;
				return;
			} else if (allowedExtensions.includes(fileExtension)) {
				this.maxSize = false;
				this.invalidFile = false;
				const reader = new FileReader();
				reader.onload = (e) => {
					console.log(e);
					this.uploadedFileName = fileName;
					this.isFileUploaded = true;
					this.inputData = file;
					this.$emit("select-value", this.inputData);
					this.$emit("reupload-value", true);
					this.$emit("update-check", true);
				};
				reader.readAsBinaryString(file);
			} else {
				console.error("Invalid file format");
				this.invalidFile = true;
				this.errorModal("Invalid file format");
				this.maxSize = false;
			}
		},
		removeFile() {
			this.inputData = [];
			this.$emit("select-value", this.inputData);
			this.$emit("file-removed");
			this.isFileUploaded = false;
			this.uploadedFileName = null;
			this.maxSize = false;
			this.invalidFile = false;
		},
	},
};
</script>

<style scoped>
.newUploadDoc-filled{
	border: 2px solid var(--bg-proTheme);
}
.validationinputfile {
	border: 2px dashed #c44040 !important;
	background: #fff5f5;
}

.newUploadDoc-innerContent-left {
	position: absolute;
	cursor: pointer;
	top: 11px;
	left: 10px;
}

@media (min-width: 1029px) {
	.upload-dynamix-flex {
		display: flex;
		justify-content: space-between;
	}
}
</style>
